(function () {
  document.addEventListener("DOMContentLoaded", function () {
    stickyHeader();

    window.addEventListener("scroll", function () {
      stickyHeader();
    });

    document.body.classList.add("js");
  });

  // Sticky header
  const stickyHeaderTop = document.querySelector(".js-header").offsetTop;
  const stickyHeader = function () {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > stickyHeaderTop) {
      document.body.classList.add("sticky-header");
    } else {
      document.body.classList.remove("sticky-header");
    }
  };
})();
